import React from 'react';

import NewsletterFormContainer from 'dpl/containers/NewsletterFormContainer';

import { ARTICLE_CONTENT_COL_CLASSES } from '../utils/constants';

export default function NewsletterSignup() {
  return (
    <div className="PrismicArticleNewsletterSignup container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <NewsletterFormContainer className="br2" />
        </div>
      </div>
    </div>
  );
}
